import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';
import { LINK_HEIGHT_DEFAULT, LINK_HEIGHT_NARROW } from '../../const';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: LINK_HEIGHT_DEFAULT,
      justifyContent: 'flex-start',

      padding: theme.spacing(0, 0.25, 0, 2),
      borderRadius: theme.shape.borderRadius,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.white,

      '&:hover': {
        backgroundColor: theme.palette.darkHover,
      },

      '&$active': {
        backgroundColor: COLORS.neutral.mediumGray,
        color: COLORS.neutral.white,
      },

      '&$outlined': {
        border: '1px solid #415A8A',
        width: '100%',

        '&:focus': {
          backgroundColor: COLORS.neutral.blackBlue,
        },
      },

      '&$narrow': {
        height: LINK_HEIGHT_NARROW,
      },
    },
    active: {},
    outlined: {},
    narrow: {},

    label: {},
    startIcon: {
      fontSize: theme.typography.pxToRem(24),
      display: 'flex',
      justifyContent: 'center',
    },
    iconStart: {
      color: COLORS.neutral.silver,

      // HINT: we need to overcome specificity of ".MuiButton-iconSizeMedium > *:first-child"
      '&&': {
        fontSize: theme.typography.pxToRem(24),
      },
    },
    endIcon: {
      marginLeft: 'auto',
      marginRight: theme.spacing(1),
      alignSelf: 'center',
      color: '#697385',
    },
  }),
  {
    name: 'SidebarButton',
  }
);
